import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { CmsConfig, DeferLoadingStrategy, I18nModule, provideConfig, RoutingModule, UrlModule } from '@spartacus/core';
import { CarouselModule, MediaModule } from '@spartacus/storefront';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ProductSearchEmptyComponent } from './product-search-empty.component';

@NgModule({
  declarations: [ProductSearchEmptyComponent],
  imports: [
    CarouselModule,
    CommonModule,
    I18nModule,
    MatIconModule,
    MediaModule,
    RouterModule,
    RoutingModule,
    SlickCarouselModule,
    UrlModule,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ShimanoEmptySearchProductsComponent: {
          component: ProductSearchEmptyComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
  ],
  exports: [ProductSearchEmptyComponent],
})
export class ProductSearchEmptyModule {}
